export function translateKey(scopeName, seriesName, metric, field) {
  if (seriesName) {
    if (!metric) {
      return ['$analytics', scopeName, seriesName, field].join('.');
    } else {
      return ['$analytics', scopeName, seriesName, 'series', metric, field].join('.');
    }
  } else {
    return ['$analytics', scopeName, metric, field].join('.');
  }
}

export function buildOverrides(data, serie, translate, scopeName, seriesName) {
  let translated = {
    aggregation: translate(`$analytics.${serie.bigLabel}`),
    label: serie.label || translate(translateKey(scopeName, seriesName, serie.metric, 'label')),
    values: translate(translateKey(scopeName, seriesName, serie.metric, 'values')),
    comparison: translate('comparison')
  };
  let key = data.key;
  let name = translated.label;
  let tooltipName = undefined;
  let color = data.color;
  let showInLegend = data.hideLegend ? false : true;
  let bigLabel = undefined;
  let comparison = serie.comparison;

  if (comparison) {
    name = `${translated.label} ${translated.comparison}`;
  }

  if (data.key) {
    tooltipName = data.tooltipName || (serie.getTooltip && serie.getTooltip(data)) || (`${data.key} ${translated.label}`);
    name = `${data.key}`;
  }

  if (serie.bigLabel) {
    if (serie.bigLabel == 'lastRowValue') {
      bigLabel = {
        label: translated.label,
        value: _.last(data.rows).value
      };
    } else {
      bigLabel = {
        label: `${translated.aggregation} ${translated.label}`,
        value: data.summary[serie.bigLabel]
      };
    }
    if (comparison) {
      bigLabel.label = `${bigLabel.label} ${translated.comparison}`;
    }
  }

  return _.merge(
    {},
    _.omit(serie, ['getData', 'query']),
    _.omitBy({
      comparison,
      bigLabel,
      tooltipName,
      key,
      name,
      color,
      showInLegend
    }, _.isUndefined)
  );
}



/** WEBPACK FOOTER **
 ** ./src/common/analyticsPanel/chartSerie.js
 **/